import React from 'react';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import { SegmentedControl, TextRegular } from '@hz-design-system/web-ui';

import { ATTRIBUTE_VALUES } from '../../../../../constants/attributes';

import Classes from './CarsSearchFormToggleGroup.module.scss';

type TCarsSearchLeaseTypeToggleProps = {
  values?: string[];
  onChangeHandler: Function;
};

const LEASE_TYPE_OPTIONS = {
  PRIVATE: [ATTRIBUTE_VALUES.LEASE_TYPE.PRIVATE_LEASE, ATTRIBUTE_VALUES.LEASE_TYPE.PERSONAL_LOAN],
  BUSINESS: [ATTRIBUTE_VALUES.LEASE_TYPE.OPERATIONAL_LEASE, ATTRIBUTE_VALUES.LEASE_TYPE.FINANCIAL_LEASE],
};

const CarsSearchLeaseTypeToggle = ({ values, onChangeHandler }: TCarsSearchLeaseTypeToggleProps) => {
  const { t } = useI18nContext();

  const getSelectedValue = () => {
    if (!values || !values.length || values[0] === '') {
      return '';
    }
    if (LEASE_TYPE_OPTIONS.PRIVATE.every((v) => values.includes(v))) {
      return 'private';
    }
    if (LEASE_TYPE_OPTIONS.BUSINESS.every((v) => values.includes(v))) {
      return 'business';
    }
    return '';
  };

  const handleChange = (value: string) => {
    if (value === 'private') {
      onChangeHandler('leaseType', LEASE_TYPE_OPTIONS.PRIVATE, 'AttributeGroupFacet', true);
    } else if (value === 'business') {
      onChangeHandler('leaseType', LEASE_TYPE_OPTIONS.BUSINESS, 'AttributeGroupFacet', true);
    } else {
      onChangeHandler('leaseType', '', 'AttributeGroupFacet', true);
    }
  };

  const options = [
    { value: '', label: t('cars.search.options.all') },
    { value: 'private', label: t('cars.search.options.leaseType.private') },
    { value: 'business', label: t('cars.search.options.leaseType.business') },
  ];

  const label = t('cars.search.fields.leaseTypeGroups');

  return (
    <div className="FormField FormField--toggleGroup">
      <div className={`FormField-Label ${Classes.label}`}>
        <TextRegular color="text-primary" strong>
          {label}
        </TextRegular>
      </div>
      <SegmentedControl value={getSelectedValue()} onChange={handleChange} options={options} aria-label={label} />
    </div>
  );
};

export default CarsSearchLeaseTypeToggle;
